import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as actions from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import Users from "./users";
import Credentials from "./credentials";
import AccountDetails from "./account_details";
import Integrations from "./integrations";
import Subscriptions from "./subscription";
import Sidebar from "./sidebar";
import Insights from "./insights";
import Activity from "../../../components/activitiy";
import ZuperPay from './zuper_pay'
import ZuperConnect from './zuper_connect'
import ZuperFleet from './zuper_fleet'
import CompanyModules from "./company_modules";
import { TOGGLECOMPANY_RESPONSE } from "../../../constants/action_types";
import CompanyPolicy from "./policy";
import moment from "moment";
import { ACL } from "../../../components/acl";
import { ADMIN, SUPERADMIN, FINANCEADMIN } from "../../../constants/roles";
import { Notes } from "./notes";
import NotFound from "../../common/not_found";

function CustomerDetails() {
  const dispatch = useDispatch();

  const { company_uid, type: pageType } = useParams();
  const [type, setType] = useState();

  const companyDetails = useSelector((state) => state.company.details);
  const companyUpdated = useSelector(
    (state) => state?.company?.update_response
  );

  useEffect(() => {
    if (companyUpdated.type === TOGGLECOMPANY_RESPONSE)
      dispatch(actions.GETCOMPANY_REQ({ company_uid }));
  }, [companyUpdated]);

  useEffect(() => {
    if (company_uid) {
      dispatch(actions.GETCOMPANY_REQ({ company_uid }));
    }
  }, [company_uid]);

  useEffect(() => {
    if (pageType) setType(pageType);
  }, [pageType]);


  return (
    <main class="-mt-24">
      <div
        class={`mx-auto group ${
          type === "insights" ? "w-full" : "w-[86rem]"
        } transition-all py-3 sm:px-6 lg:px-8`}
      >
        <div class="flex flex-1 h-full space-x-4">
          <aside class="w-80 mt-3 overflow-y-auto rounded-lg shadow self-start sticky top-4">
            <div class="p-4 bg-white">
              <div class="relative">
                <div class="relative flex items-center space-x-3 py-2">
                  <div class="flex-shrink-0">
                    <img
                      class="h-12 w-12 object-contain rounded-full"
                      src={companyDetails?.company_logo || ""}
                      alt=""
                    />
                  </div>
                  <div class="min-w-0 flex-1">
                    <p class="text-lg font-medium text-gray-900">
                      {companyDetails?.company_name || "...."}
                    </p>
                    <p class="text-xs text-gray-500">
                      Created{" "}
                      {companyDetails?.created_at
                        ? moment(companyDetails?.created_at).format(
                            "DD MMM, YYYY"
                          )
                        : "...."}{" "}
                      {companyDetails?.created_by?.fullName &&
                        `by ${companyDetails?.created_by?.fullName}`}
                    </p>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <Sidebar
                company_id={company_uid}
                companyDetails={companyDetails}
                type={type}
              ></Sidebar>
            </div>
          </aside>

          <section class="flex flex-1 min-w-0 mt-0 flex-col lg:order-last">
            {type === "users" ? (
              <Users
                company_uid={company_uid}
                companyDetails={companyDetails}
              ></Users>
            ) : type === "credentials" ? (
              <Credentials
                company_uid={company_uid}
                companyDetails={companyDetails}
              ></Credentials>
            ) : type === "details" ? (
              <AccountDetails
                company_uid={company_uid}
                companyDetails={companyDetails}
              ></AccountDetails>
            ) : type === "integrations" ? (
              <Integrations
                company_uid={company_uid}
                companyDetails={companyDetails}
              ></Integrations>
            )
             : type === "subscriptions" ? (
              <Subscriptions
                company_uid={company_uid}
                companyDetails={companyDetails}
              ></Subscriptions>
            ) 
            : type === "activity" ? (
              <Activity uid={company_uid} type="CUSTOMER"></Activity>
            ) : type === "modules" ? (
              <ACL
                showFor={[SUPERADMIN, ADMIN, FINANCEADMIN]}
                redirectTo={`/customers/${company_uid}/details`}
              >
                <CompanyModules company_uid={company_uid} />
              </ACL>
            ) : type === "policy" ? (
              <CompanyPolicy
                company_uid={company_uid}
                companyDetails={companyDetails}
              />
            ) : type === "notes" ? (
              <Notes companyDetails={companyDetails} />
            ) : type === "insights" ? (
              <Insights companyDetails={companyDetails} />
            ) : type === "zuper_pay" ? (
              <ZuperPay companyDetails={companyDetails} />
            ) : type === "zuper_connect" ? (
              <ACL
                showFor={[SUPERADMIN, ADMIN, FINANCEADMIN]}
                redirectTo={`/customers/${company_uid}/details`}
              >
                <ZuperConnect
                  company_uid={company_uid}
                  companyDetails={companyDetails}
                />
              </ACL>
            ) : type === "zuper_fleet" ? (
              <ACL
                showFor={[SUPERADMIN, ADMIN, FINANCEADMIN]}
                redirectTo={`/customers/${company_uid}/details`}
              >
                <ZuperFleet
                  company_uid={company_uid}
                  companyDetails={companyDetails}
                />
              </ACL>
            ) :(
              <NotFound className="mt-3 rounded-lg" />
            )}
          </section>
        </div>
      </div>
    </main>
  );
}

export default CustomerDetails;
